var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "520",
        persistent: _vm.processing || _vm.downloading,
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "navy darken-1 white--text" },
            [
              _c("div", [_vm._v("Elimina squadra definitivamente: ")]),
              _vm._v(" "),
              _vm.squadra
                ? _c("div", { staticClass: "font-weight-bold ml-2" }, [
                    _vm._v(_vm._s(_vm.squadra.name)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: {
                    icon: "",
                    disabled: _vm.processing || _vm.downloading,
                    "aria-label": "Chiudi",
                  },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pa-4" },
            [
              _vm.squadra
                ? [
                    _c(
                      "v-alert",
                      {
                        staticClass: "mb-2 ",
                        attrs: { type: "error", text: "", dense: "" },
                      },
                      [
                        _vm._v(
                          "\n            La squadra verrá eliminata definitivamente. Un nuovo partecipante potrà iscriversi all'asta (tramite normale link di invito)\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.numeroCalciatori > 0
                      ? [
                          _c("p", [
                            _vm._v(
                              "ATTENZIONE: La squadra che stai per eliminare aveva giá una rosa"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex justify-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    outlined: "",
                                    color: "primary",
                                    loading: _vm.downloading,
                                    disabled: _vm.processing,
                                  },
                                  on: { click: _vm.download },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("file_download")]
                                  ),
                                  _vm._v(
                                    "\n              Scarica Rosa\n            "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-caption mt-2 mb-4" }, [
                            _vm._v(
                              '\n            Perché scaricarne la rosa? Perché sará eliminata quando eliminerai la squadra. Ti sará quindi utile se vorrai riassegnarne manualmente i calciatori alla nuova squadra che si iscriverá (puoi farlo tramite la modalitá d\'asta "Admin assegna").\n          '
                            ),
                          ]),
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  staticClass: "mb-2 ",
                  attrs: { type: "info", text: "", dense: "" },
                },
                [
                  _c("div", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      "Puoi eliminare massimo " +
                        _vm._s(_vm.Constants.MAX_ELIMINAZIONI_SQUADRE) +
                        " squadre in ciascuna asta."
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.disabledReason
                    ? _c(
                        "div",
                        { staticClass: "text-caption mt-1" },
                        [
                          _vm.disponibili === 1
                            ? [
                                _vm._v(
                                  "\n            Questa è l'ultima eliminazione disponibile per questa asta.\n          "
                                ),
                              ]
                            : _vm.disponibili === 2
                            ? [
                                _vm._v(
                                  "\n            Dopo questa potrai eliminare ancora una squadra.\n          "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n            Dopo questa potrai eliminare ancora " +
                                    _vm._s(_vm.disponibili - 1) +
                                    " squadre.\n          "
                                ),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.disabledReason || _vm.error
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-4 mb-0",
                      attrs: { type: "error", outlined: "", dense: "" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.error || _vm.disabledReason) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "pa-4 pt-0 flex-wrap" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    disabled: _vm.processing || _vm.downloading,
                  },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_vm._v("Annulla")]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "error",
                    loading: _vm.processing,
                    disabled: !!_vm.disabledReason || _vm.downloading,
                  },
                  on: { click: _vm.elimina },
                },
                [_vm._v("\n        Elimina definitivamente\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }